import { z } from 'zod'

import { CheckedAddress } from '../types/CheckedAddress.js'

export const checkedAddressSchema = z.string().transform((address, ctx) => {
  try {
    return CheckedAddress(address)
  } catch {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Invalid Ethereum address: ${address}`,
    })
    return z.NEVER
  }
})
